import React from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const genders = [
  {name: '男性', id: 'man'},
  {name: '女性', id: 'woman'},
]

export const Genders = () => {
  return <MultiTagFilteringFieldRow header="性別" name="genders" list={withNull(genders)} shouldUnregister />
}
